import { Box, Button, Text } from "grommet";
import React, { useEffect } from "react";
import { use } from "react";

function LogoutPage() {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/login";
    }, 3000);
  }, []);

  return (
    <Box pad="small" justify="center" align="center" direction="column" fill>
      <Box pad="small" justify="center" direction="row">
        <Text size="large" color="dark-3">
          You have been logged out and will be automatically redirected to the
          login page in a few seconds. Alternatively, you can click the button
          below to return to the login page.
        </Text>
      </Box>

      <Box pad="small" justify="center" direction="row">
        <Button
          primary
          label="Login"
          onClick={() => (window.location.href = `/login`)}
        />
      </Box>
    </Box>
  );
}

export default LogoutPage;
